<ion-button
  class="loading-button"
  (ionClick)="onInnerPress($event)"
  (click)="onInnerPress($event)"
  [type]="type"
  [expand]="expand"
  [fill]="fill"
  [color]="color"
  [size]="size"
  [shape]="shape"
  [strong]="strong"
  [disabled]="isDisabled"
  [routerLink]="routerLink"
  [routerDirection]="routerDirection"
  [href]="href"
  [target]="target"
  [download]="download"
  [rel]="rel"
  [attr.aria-busy]="loading ? 'true' : null"
>
  @if (loading) {
    <ion-spinner
      name="dots"
      slot="start"
      class="loading-button__spinner"
      aria-hidden="true"
    ></ion-spinner>
  } @else if (startIcon) {
    <ion-icon
      [name]="startIcon"
      slot="start"
      class="loading-button__start-icon"
      aria-hidden="true"
    ></ion-icon>
  }
  <span class="loading-button__label">
    @if (loading && loadingText) {
      {{ loadingText }}
    } @else {
      <ng-content></ng-content>
    }
  </span>
  @if (!loading && endIcon) {
    <ion-icon
      [name]="endIcon"
      slot="end"
      class="loading-button__end-icon"
      aria-hidden="true"
    ></ion-icon>
  }
</ion-button>
